import React, { useEffect, useState } from "react";
import { makeRequest } from "../services/api";
import { webEndPoint } from "../constants/globalConstants";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { toast } from "react-toastify";
export default function Checkout() {
    const [cartData, setCartData] = useState({});
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [address, setAddress] = useState({
        name: "",
        phone: "",
        address1: "",
        address2: "",
        city: "",
        pincode: "",
        landmark: "",
        district_id: "",
        state_id: ""
    });
    
    useEffect(() => {
        fetchAllData();
    }, []);
    const fetchAllData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "states";
            const response = await makeRequest("get", url);
            if (response) {
                setStateData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            const res = await makeRequest("get", webEndPoint + "cart/" + localStorage.getItem("userID")
            );
            setCartData(res.data.cart);
            setItems(res.data.items);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
        try {
            const res = await makeRequest("get", webEndPoint + "user/" + localStorage.getItem("userID")
            );
            const u = res.data;
            setAddress({
                name: u.first_name,
                phone: u.mobile_number,
                address1: u.address_line1,
                address2: u.address_line2,
                city: u.city,
                pincode: u.pincode
            });
        } catch (err) {
            console.error(err);
        }
    };
    const subtotal = items.reduce((acc, item) => acc + Number(item.price) * item.quantity, 0) || 0;
    const shipping = subtotal > 1000 ? 0 : 50;
    const total = subtotal + shipping;
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddress((prev) => ({ ...prev, [name]: value }));
    };
    const placeOrder = async () => {
        const qtyUpdate = {
            "user_id": "",
            "cart_id": "",
            "total_amount": "",
            "tax_amount": "",
            "discount_amount": "",
            "final_amount": "",
            "address_line1": address.address1,
            "address_line2": address.address2,
            "city": address.city,
            "district_id": address.district_id,
            "state_id": address.state_id,
            "pincode": address.pincode,
            "landmark": address.landmark,
            "payment_method": "Razorpay",
            "payment_status": "PENDING"
        }
        try {
            let url = webEndPoint + "cart/update";
            const response = await makeRequest("put", url, qtyUpdate);
            if (response) {
                handlePlaceOrder();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleStateChange = async (e) => {
        setLoading(true);
        const stateId = e.target.value;
        setAddress((prev) => ({
            ...prev,
            state_id: stateId,
            district_id: ""
        }));
        try {
            const url = webEndPoint + "districts/state/" + stateId;
            const res = await makeRequest("get", url);
            if (res) {
                setDistrictData(res.data);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    const handleDistrictChange = (e) => {
        const districtId = e.target.value;
        setAddress((prev) => ({
            ...prev,
            district_id: districtId
        }));
    };
    const handlePlaceOrder = async () => {
        // try {
        //     const res = await makeRequest("post", webEndPoint + "payment/create-order", {
        //         amount: total
        //     });
        //     const order = res.data.order;
        //     const options = {
        //         key: "YOUR_RAZORPAY_KEY_ID",
        //         amount: order.amount,
        //         currency: order.currency,
        //         name: "Senthanamuthan Store",
        //         description: "Order Payment",
        //         order_id: order.id,
        //         handler: async function (response) {
        //             await verifyPayment(response, order);
        //         },
        //         prefill: {
        //             name: address.name,
        //             email: "test@example.com",
        //             contact: address.phone
        //         },
        //         theme: {
        //             color: "#e05da3"
        //         }
        //     };
        //     const rzp = new window.Razorpay(options);
        //     rzp.open();
        // } catch (err) {
        //     console.error(err);
        // }
    };
    const [shippingMethod, setShippingMethod] = useState("india_post");
    return (
        <div>
            <Header />
            <div className="checkout-page">
                <h2>Checkout</h2>
                <div className="checkout-section">
                    <h3>Delivery Address</h3>
                    <input name="name" value={address.name} onChange={handleChange} placeholder="Name" />
                    <input name="phone" value={address.phone} onChange={handleChange} placeholder="Phone" />
                    <select name="state_id" value={address.state_id} onChange={handleStateChange}>
                        <option value="">Select State</option>
                        {stateData?.map((s) => (
                            <option key={s.rfId} value={s.rfId}>{s.state_name}</option>
                        ))}
                    </select>
                    <select name="district_id" value={address.district_id} disabled={!address.state_id} onChange={handleDistrictChange} >
                        <option value="">Select District</option>
                        {districtData?.map((d) => (
                            <option key={d.district_id} value={d.district_id}>{d.district_name}</option>
                        ))}
                    </select>
                    <input name="address1" value={address.address1} onChange={handleChange} placeholder="Address Line 1" />
                    <input name="address2" value={address.address2} onChange={handleChange} placeholder="Address Line 2" />
                    <input name="city" value={address.city} onChange={handleChange} placeholder="City" />
                    <input name="pincode" value={address.pincode} onChange={handleChange} placeholder="Pincode" />
                </div>
                <div className="checkout-section">
                    <h3>Order Summary</h3>
                    {items.map((item) => (
                        <div key={item.cart_item_id} className="checkout-item">
                            <img src={item.color_image_url} width={60} />
                            <div>
                                <p>{item.product_name}</p>
                                <p>Qty: {item.quantity}</p>
                            </div>
                            <div>₹{item.price}</div>
                        </div>
                    ))}
                </div>
                {/* <div className="checkout-section">
                    <h3>Price Details</h3>
                    <p>Subtotal: ₹{subtotal}</p>
                    <p>Shipping: ₹{shipping}</p>
                    <h4>Total: ₹{total}</h4>
                </div> */}
                <div className="checkout-section">
                    <h3>Price Details</h3>

                    {/* SUBTOTAL */}
                    <div className="price-row">
                        <span>Subtotal</span>
                        <span>₹{subtotal}</span>
                    </div>

                    {/* SHIPPING OPTIONS */}
                    <h4 style={{ marginTop: "10px" }}>Shipping Method</h4>

                    <div className="shipping-box">
                        <label className={shippingMethod === "india_post" ? "active" : ""}>
                            <input
                                type="radio"
                                name="shipping"
                                value="india_post"
                                checked={shippingMethod === "india_post"}
                                onChange={(e) => setShippingMethod(e.target.value)}
                            />
                            India Post (₹40)
                        </label>

                        <label className={shippingMethod === "st_courier" ? "active" : ""}>
                            <input
                                type="radio"
                                name="shipping"
                                value="st_courier"
                                checked={shippingMethod === "st_courier"}
                                onChange={(e) => setShippingMethod(e.target.value)}
                            />
                            ST Courier (₹80)
                        </label>
                    </div>

                    {/* SHIPPING COST */}
                    <div className="price-row">
                        <span>Shipping</span>
                        <span>₹{shipping}</span>
                    </div>

                    {/* DISCOUNT */}
                    <div className="coupon-box">
                        <input type="text" placeholder="Enter discount code" />
                        <button>Apply</button>
                    </div>

                    <hr />

                    {/* TOTAL */}
                    <div className="price-row total">
                        <span>Total</span>
                        <span>₹{total}</span>
                    </div>
                </div>
                <button className="checkout-btn" onClick={() => placeOrder()} disabled={loading}>
                    {loading ? "Placing..." : "Place Order"}
                </button>
            </div>
            <Footer />
        </div>
    );
}